import {IosServerName, OrderDestination} from "app/orders/models/OrderRecord";
import {IosOrderDestinations} from "./IosOrderDestinations";
import {IressDemo, Morrison, MorrisonTest, Om, OmTest, Phillip, PhillipTest, Shaw, Ausiex, AusiexTest} from "./OrderDestinations";

export class OrderDestinationService {

    // NOTE: This configuration is duplicated in the BE codebase. Any changes to it will need to be reflected there also
    private static DefaultAsxDestinations: Map<IosServerName, IosOrderDestinations> = new Map([
        [IosServerName.IRESS_DEMO, IressDemo],
        [IosServerName.MORRISON, Morrison],
        [IosServerName.MORRISON_TEST, MorrisonTest],
        [IosServerName.OM, Om],
        [IosServerName.OM_TEST, OmTest],
        [IosServerName.PHILLIP, Phillip],
        [IosServerName.AUSIEX, Ausiex],
        [IosServerName.PHILLIP_TEST, PhillipTest],
        [IosServerName.AUSIEX_TEST, AusiexTest],
        [IosServerName.SHAW, Shaw],
    ]);

    public static orderDestinations(iosServerName: IosServerName): ReadonlyArray<OrderDestination> {
        const destination = this.DefaultAsxDestinations.get(iosServerName);
        if (!destination) {
            throw Error(`Order destination not defined for ${iosServerName}`);
        }
        return destination.rootDestinations;
    }
}
